import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as c } from "../SvgIcon.js";
const v = (r) => /* @__PURE__ */ o(c, { ...r, children: /* @__PURE__ */ o("path", { d: "M5.18176 15.9373c0 .9173.75052 1.6679 1.66783 1.6679h6.67131c.9173 0 1.6678-.7506 1.6678-1.6679V6.7782H5.18176v9.1591ZM12.6731 3.44274v-.83391H7.68349v.83391H4.34784v1.66782H16.0087V3.44274h-3.3356Z" }) });
export {
  v as TrashCan
};
//# sourceMappingURL=TrashCan.js.map
